import { ProcedimentoSelectModel } from 'components/form/field/select/ProcedimentoSelectField'
import { ProcedimentoSelect } from 'components/select/ProcedimentoSelect/ProcedimentoSelect'
import { GrupoProcedimentoEnum, IdentidadeGeneroEnum, SexoEnum } from 'graphql/types.generated'
import React, { useEffect, useState } from 'react'

interface ExamesSelectProps {
  identidadeGeneroDbEnum: IdentidadeGeneroEnum
  sexo: SexoEnum
  dataNascimento: LocalDate
  onChange(value: ProcedimentoSelectModel): void
}

export const ExamesSelect = (props: ExamesSelectProps) => {
  const { sexo, identidadeGeneroDbEnum, dataNascimento, onChange } = props

  const [inputValue, setInputValue] = useState<ProcedimentoSelectModel>()

  useEffect(() => {
    if (inputValue) {
      onChange(inputValue)
      setInputValue(undefined)
    }
  }, [inputValue, onChange])

  return (
    <ProcedimentoSelect
      sexo={sexo}
      identidadeGeneroDbEnum={identidadeGeneroDbEnum}
      dataNascimento={dataNascimento}
      gruposProcedimento={[GrupoProcedimentoEnum.FINALIDADE_DIAGNOSTICA]}
      placeholder='Pesquise por exame para inserir o resultado'
      value={inputValue}
      onChange={(item: ProcedimentoSelectModel) => setInputValue(item)}
    />
  )
}
